// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__IyDx9","spin":"loader_spin__FhyXA"};